<template>
  <div
    :class="['sf-heading']"
    v-bind="$attrs"
  >
    <slot
      name="title"
      v-bind="$props"
    >
      <component
        :is="`h${level}`"
        class="sf-heading__title"
        :class="level > 1 && headingClass(level)"
      >
        {{ title }}
      </component>
    </slot>
    <slot
      name="description"
      v-bind="$props"
    >
      <div
        :class="{
          'display-none': !hasDescription(description, $slots),
        }"
        class="sf-heading__description"
      >
        {{ description }}
      </div>
    </slot>
  </div>
</template>
<script>

export default {
  name: 'SfHeading',
  props: {
    level: {
      type: Number,
      default: 2,
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
  methods: {
    hasDescription(descriptionProp, slots) {

      return !!descriptionProp || slots.description;
    
    },
    headingClass(headingLevel) {

      return headingLevel <= 6 ? `h${headingLevel}` : 'h2';
    
    },
  },
};

</script>
<style lang="scss">
@use "~/assets/scss/helpers/_breakpoints" as breakpoints;
@use "~/assets/scss/helpers/_layout" as layout;
@use "~/assets/scss/helpers/_typography" as typography;
.sf-heading {
  box-sizing: border-box;
  padding: var(--heading-padding, 0 0 var(--spacer-xs) 0);
  text-align: var(--heading-text-align, center);

  &__title {
    margin: var(--heading-title-margin, 0);
    color: var(--heading-title-color, var(--c-text));

    @include typography.font(
      --heading-title-font,
      var(--font-weight--semibold),
      var(--h1-font-size),
      1.6,
      var(--font-family--secondary)
    );

    &.h2 {
      font-size: var(--heading-title-font-size, var(--h2-font-size));
      font-weight: var(--heading-title-font-weight, var(--font-weight--normal));
    }

    &.h3 {
      font-size: var(--heading-title-font-size, var(--h3-font-size));
      font-weight: var(--heading-title-font-weight, var(--font-weight--semibold));
    }

    &.h4 {
      font-size: var(--heading-title-font-size, var(--h4-font-size));
      font-weight: var(--heading-title-font-weight, var(--font-weight--medium));
    }

    &.h5 {
      font-size: var(--heading-title-font-size, var(--h5-font-size));
      font-weight: var(--heading-title-font-weight, var(--font-weight--normal));
    }

    &.h6 {
      font-size: var(--heading-title-font-size, var(--h6-font-size));
      font-weight: var(--heading-title-font-weight, var(--font-weight--normal));
    }
  }

  &__description {
    margin: var(--heading-description-margin, var(--spacer-sm) 0 0);
    color: var(--heading-description-color, var(--c-text));

    @include typography.font(
      --heading-description-font,
      var(--font-weight--normal),
      var(--font-size--base),
      1.6,
      var(--font-family--secondary)
    );
  }

  @include breakpoints.for-desktop {
    --heading-padding: 0;
    --heading-border: 0;
    --heading-text-align: center;
  }

  &--underline {
    @include layout.border(--heading-border, 0 0 1px 0, solid, var(--c-light));
  }

  &--left {
    --heading-text-align: left;
  }

  &--right {
    --heading-text-align: right;
  }
}
</style>
